import { useQuery } from '@tanstack/react-query';

import { DataLakes } from '@graylog/enterprise-api';

import useFeature from 'hooks/useFeature';
import type { DataLakeInfoArray } from 'data-lake/preview/Types';
import { INTERNAL_DATA_LAKE_INFO } from 'data-lake/Constants';

const fetchDataLakesList = (): Promise<DataLakeInfoArray> =>
  DataLakes.getActive().then((dataLakes) =>
    dataLakes.map((dataLake) => ({
      ...dataLake,
      storageType: dataLake.storage_type,
    })),
  );

const useActiveDataLakes = (): {
  data: DataLakeInfoArray;
  isInitialLoading: boolean;
  hasActiveDataLake: boolean;
} => {
  const featureIsEnabled = useFeature('external_data_lake_search');

  const defaultData = featureIsEnabled ? [] : [INTERNAL_DATA_LAKE_INFO];

  const { data = defaultData, isLoading } = useQuery<DataLakeInfoArray>({
    queryKey: ['data-lake', 'infos'],
    queryFn: fetchDataLakesList,
    enabled: featureIsEnabled,
  });

  return {
    data,
    isInitialLoading: isLoading,
    hasActiveDataLake: data?.length > 0,
  };
};

export default useActiveDataLakes;
